import MainLayout from '../layout/MainLayout'
import HomePage from '../pages/HomePage'
import UsersPage from '../pages/UsersPage'
import SupportPage from '../pages/SupportPage'
import SupportDetailsPage from '../pages/SupportDetailsPage'
import FacebookAds from '../pages/FacebookAds'
import AccountPage from '../pages/AccountPage'
import { PATH, PATH_LOGIN } from './constant'
import ConfirmEmail from '../pages/ConfirmEmail'
import PasswordCreatePage from '../pages/PasswordCreatePage'
import SupportCreateTicketPage from '../pages/SupportCreateTicketPage'
import LocalPresencePage from '../pages/LocalPresencePage'

const MainRoutes = {
  element: <MainLayout />,
  children: [
    {
      path: PATH.HOME,
      element: <HomePage />
    },
    {
      path: PATH.TEAM,
      element: <UsersPage />
    },
    {
      path: PATH.SUPPORT,
      element: <SupportPage />
    },
    {
      path: PATH.SUPPORT_DETAILS(':id'),
      element: <SupportDetailsPage />
    },
    {
      path: PATH.SUPPORT_CREATE,
      element: <SupportCreateTicketPage />
    },
    {
      path: PATH.ADS,
      element: <FacebookAds />
    },
    {
      path: PATH.ACCOUNT,
      element: <AccountPage />
    },
    {
      path: PATH.CONFIRM_EMAIL(':id/'),
      element: <ConfirmEmail />
    },
    {
      path: PATH_LOGIN.PASSWORD_CREATE,
      element: <PasswordCreatePage />
    },
    {
      path: PATH.LOCAL_PRESENCE,
      element: <LocalPresencePage />
    }
  ]
}

export default MainRoutes
